import {
  QaQuizLeaderboardItem,
  CategoryQuizLeaderboardItem,
  QuizType,
} from "@/types/quiz";

export const isQaQuizLeaderboardItem = (
  item: QaQuizLeaderboardItem | CategoryQuizLeaderboardItem
): item is QaQuizLeaderboardItem => {
  return true;
};

export const isCategoryQuizLeaderboardItem = (
  item: QaQuizLeaderboardItem | CategoryQuizLeaderboardItem
): item is CategoryQuizLeaderboardItem => {
  return true;
};

export const getLeaderboardHeading = (
  quizType: QuizType,
  lobbyUUID: string | null
) => {
  if (quizType === QuizType.QuestionAnswer) {
    return lobbyUUID ? "Quiz Lobby Leaderboard" : "Quiz Leaderboard";
  }
  return lobbyUUID ? "Lobby Quiz Results" : "Top Quiz Results";
};

export function getRankColor(rank: number) {
  if (rank === 1) return "#FAAF00";
  if (rank === 2) return "#9B9B9B";
  if (rank === 3) return "#9E3E09";
  return "inherit";
}
